import type {
  DefaultErrorBody,
  ResponseBody,
  RestOptions,
} from "common/api-client/rest";
import { rest } from "common/api-client/rest";
import {
  deleteTokenCookie,
  getTokenCookie,
} from "common/context/auth/token-cookie";
import apiURL from "common/config/api-url.config";

function handleUnauthorized() {
  deleteTokenCookie();
  window.location.assign(
    `${window.location.origin}${window.location.pathname}`,
  );
}

export async function apiClient<TResponseBody extends ResponseBody>(
  endpoint: string,
  customConfig: Omit<
    RestOptions<DefaultErrorBody>,
    "baseURL" | "onUnauthorized" | "getMessageFromErrorResponse"
  > = {},
) {
  return rest<TResponseBody>(endpoint, {
    ...customConfig,
    baseURL: apiURL,
    onUnauthorized: handleUnauthorized,
    headers: {
      Authorization: `Bearer ${getTokenCookie()}`,
      ...customConfig.headers,
    },
  });
}
